import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import "antd/dist/antd.css";
import { Tabs, Row, Col, Button, Checkbox, Card, Input } from "antd";
import styles from "./DashBoard.module.scss";
import textStyles from "../../components/DashBoard/BookingSummary/BookingSummary.module.scss";
import DashBoardFilter from "./DashBoardFilter";
import { useTripsCtx } from "../../context/TripDetailsContext";
import { FilterCalendarIcon, leftOutlinedIcon } from "../../assets/images";
import moreOutlined from "../../assets/icons/moreOutlined.svg";
import YourPlan from "./Subscription/YourPlan/YourPlan";
import { usePaginationCtx } from "../../context/PaginationContext";
import Payment from "./Payment/Payment";
import navigateAddServiceUser from "../../helpers/navigateAddServiceUser";
import { usePersonSummaryCtx } from "../../context/PersonSummaryContext";
import { TrackAnalytics } from "../../types/ApplicationTypes";
import { useWindowSize } from "../../hooks/useWindowSize";
import PersonSearch from "./PersonSearch";
import ServicesTable from "./ServicesTable/ServicesTable";
import { useDashboardCtx } from "../../context/DashboardContext";
import { useDashboardTripServices } from "../../hooks/useDashboardTripServices";
import EllipsisText from "../../helpers/EllipsisText/EllipsisText";
import ViewProfileDrawer from "./MemberProfile/ViewProfileDrawer";
import { getServiceUserDetails } from "../../helpers/personHelpers";
import { IServiceUser } from "../ServiceUsers/Interfaces/IServiceUser";
import { IServiceUserInfo } from "../../types/ServiceUserInfo";
import ServiceSelectionDrawer from "./ServiceSelection/ServiceSelectionDrawer";
import ServiceSelectionMobile from "./ServiceSelection/ServiceSelectionMobile";
import DashBoardFilterButton from "./DashBoardFilterButton";
import DashBoardPersonActionButtons from "./DashBoardPersonActionButtons";
import DashBoardFilterButtonMobile from "./DashBoardFilterButtonMobile";
import { mode } from "../../services";

type DataRange = {
  startDate: string;
  endDate: string;
};

const DashBoard = () => {
  const {
    serviceDataCtx,
    upcomingTripDetailsCtx,
    pastTripDetailsCtx,
    favoriteTripDetailsCtx,
  } = useTripsCtx();
  const { caregiverSummaryInfo } = usePersonSummaryCtx();
  const [serviceData, setServiceData] = serviceDataCtx;
  const [upcomingTripDetails] = upcomingTripDetailsCtx;
  const [pastTripDetails] = pastTripDetailsCtx;
  const [favoriteTripDetails] = favoriteTripDetailsCtx;
  const [isMobileView, setIsMobileView] = useState<boolean>(false);

  const { upcomingDateRangeCtx, resetPagination } = usePaginationCtx();
  const {
    activeTabCtx,
    selectedPersonIdCtx,
    showTabsCtx,
    pastDateRangeCtx,
    favoriteDateRangeCtx,
    showDateRangeCtx,
  } = useDashboardCtx();
  const [selectedPersonId, setSelectedPersonId] = selectedPersonIdCtx;
  const [activeTab, setActiveTab] = activeTabCtx;
  const [pastDateRange, setPastDateRange] = pastDateRangeCtx;
  const [upcomingDateRange, setUpcomingDateRange] = upcomingDateRangeCtx;
  const [favoriteDateRange, setFavoriteDateRange] = favoriteDateRangeCtx;
  const [showDateRange, setShowDateRange] = showDateRangeCtx;
  const [showTabs, setShowTabs] = showTabsCtx;
  const { width } = useWindowSize();
  const showMobileDashboardView = isMobileView && showTabs;
  const [isOpenFilter, setIsOpenFilter] = useState<boolean>(false);
  const [isOpenMemberProfileDrawer, setIsOpenMemberProfileDrawer] = useState<
    boolean
  >(false);
  const [memberProfileDetails, setMemberProfileDetails] = useState<
    IServiceUserInfo
  >();
  const [isServiceSelectionDrawer, setIsServiceSelectionDrawer] = useState<
    boolean
  >(false);
  function handleMemberProfileDrawer(personId: number) {
    const selectedProfileDetails = getServiceUserDetails(personId, serviceData);
    setMemberProfileDetails(selectedProfileDetails);
    setIsOpenMemberProfileDrawer(true);
  }

  const selectedServiceUser = serviceData.find(
    (person: { firstName: string; lastName: string; personId: number }) =>
      person.personId === parseInt(selectedPersonId)
  );
  const history = useHistory();
  const { paginationConfig } = useDashboardTripServices();
  const { TabPane } = Tabs;
  const selectedServiceUserName = `${selectedServiceUser?.firstName} ${selectedServiceUser?.lastName}`;

  function updateProfile(
    personId: number,
    serviceUsersList: IServiceUserInfo[]
  ) {
    const updatedProfileDetails = getServiceUserDetails(
      personId,
      serviceUsersList
    );
    setMemberProfileDetails(updatedProfileDetails);
  }

  const handleAddServiceUser = () =>
    navigateAddServiceUser(
      serviceData,
      caregiverSummaryInfo.personId,
      history,
      "Dashboard"
    );
  const showDrawer = (): void => {
    setIsOpenFilter(true);
  };
  const redirect = (url: string) => {
    resetPagination();
    history.push(url);
  };

  const handleScheduleAServiceButtonClick = () => {
    TrackAnalytics(
      "/DashBoard",
      "Schedule a Service - Dashboard",
      "DashBoard Page"
    );
    redirect(
      `/DashBoard/ScheduleService/ScheduleServiceCalender/${caregiverSummaryInfo.personId}/${selectedPersonId}`
    );
  };

  const handleScheduleServiceDrawer = () => {
    setIsServiceSelectionDrawer(true);
  };

  const handleUpcomingDateRangeChange = (newRange: DataRange) => {
    setUpcomingDateRange(newRange);
  };

  const handlePastDateRangeChange = (newRange: DataRange) => {
    setPastDateRange(newRange);
  };
  useEffect(() => {
    setIsMobileView(width <= 992);
    if (isMobileView) {
      setShowTabs(false);
    }
  }, [width]);

  function handleTabChange(activeKey: string): void {
    setActiveTab(activeKey);
  }
  const handleBackToServiceUser = () => {
    setShowTabs(false);
  };

  function getDateRange() {
    switch (activeTab) {
      case "1":
        return `${upcomingDateRange.startDate} - ${upcomingDateRange.endDate}`;
      case "2":
        return `${pastDateRange.startDate} - ${pastDateRange.endDate}`;
      case "3":
        return `${favoriteDateRange.startDate} - ${favoriteDateRange.endDate}`;
      default:
        return `${upcomingDateRange.startDate} - ${upcomingDateRange.endDate}`;
    }
  }

  const handleClick = () => {
    if (mode() === "PROD") {
      handleScheduleAServiceButtonClick();
    } else {
      handleScheduleServiceDrawer();
    }
  };

  return (
    <>
      <Row
        className={`${
          showMobileDashboardView ? styles.dashboardContainerMargin : null
        } ${styles.dashboardContainer} `}
      >
        <Col xs={isMobileView ? 24 : 0} lg={18}>
          <Card
            className={`${
              showMobileDashboardView ? styles.dashboardHeaderHideStyle : null
            }  ${styles.serviceTableContainer}`}
          >
            <Row className={styles.defaultPadding}>
              <PersonSearch
                serviceData={serviceData}
                handleAddServiceUser={handleAddServiceUser}
                showMobileDashboardView={showMobileDashboardView}
              />

              <Col
                className={`${
                  width <= 992 ? styles.allUserTableContainer : ""
                }`}
                xs={24}
                lg={15}
              >
                {width >= 992 ? (
                  <>
                    <Row className={styles.allServiceUserHeadingContainer}>
                      <Col xs={24} md={9} className={textStyles.normalText20}>
                        {selectedPersonId === "" ? (
                          <span>All Service Users </span>
                        ) : (
                          <EllipsisText
                            text={selectedServiceUserName}
                            maxVisibleTextLength={20}
                          />
                        )}
                      </Col>
                      {activeTab !== "3" ? (
                        <DashBoardFilterButtonMobile
                          getDateRange={getDateRange}
                          showDrawer={showDrawer}
                        />
                      ) : (
                        <Col
                          xs={{ span: 24, order: 3 }}
                          md={{ span: 10, order: 2 }}
                        ></Col>
                      )}
                    </Row>
                    {selectedPersonId !== "" && (
                      <Row className={styles.btnContainer}>
                        <Col span={12}>
                          <Button
                            className={styles.viewProfileBtnStyle}
                            onClick={() =>
                              handleMemberProfileDrawer(
                                Number(selectedPersonId)
                              )
                            }
                          >
                            View profile
                          </Button>
                        </Col>

                        <Col span={12} className={styles.contentRight}>
                          <Button
                            className={styles.scheduleServiceBtnStyle}
                            onClick={handleClick}
                          >
                            Schedule service
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </>
                ) : (
                  <>
                    <Row
                      className={` ${
                        showMobileDashboardView
                          ? styles.allServiceUserHeadingContainerMOb
                          : styles.showMobDashboardViewStyle
                      }`}
                    >
                      <DashBoardPersonActionButtons
                        handleBackToServiceUser={handleBackToServiceUser}
                        selectedPersonId={selectedPersonId}
                        selectedServiceUserName={selectedServiceUserName}
                      />

                      {activeTab !== "3" && (
                        <DashBoardFilterButton
                          getDateRange={getDateRange}
                          showDrawer={showDrawer}
                        />
                      )}
                    </Row>
                    {selectedPersonId !== "" && showMobileDashboardView && (
                      <Row className={styles.btnContainer}>
                        <Col span={12}>
                          <Button
                            className={styles.viewProfileBtnStyle}
                            onClick={() =>
                              handleMemberProfileDrawer(
                                Number(selectedPersonId)
                              )
                            }
                          >
                            View profile
                          </Button>
                        </Col>

                        <Col span={12} className={styles.contentRight}>
                          <Button
                            className={styles.scheduleServiceBtnStyle}
                            onClick={handleClick}
                          >
                            Schedule service
                          </Button>
                        </Col>
                      </Row>
                    )}
                  </>
                )}

                {isMobileView && !showMobileDashboardView ? (
                  <></>
                ) : (
                  <Col className={styles.tabsContainerStyle}>
                    <Tabs
                      className={styles.tabsContainer}
                      onChange={handleTabChange}
                      activeKey={activeTab}
                    >
                      <TabPane tab="Upcoming" key="1">
                        <ServicesTable
                          dataSource={upcomingTripDetails}
                          paginationConfig={paginationConfig}
                          handleServiceUser={handleMemberProfileDrawer}
                        />
                      </TabPane>

                      <TabPane tab="Past" key="2">
                        <ServicesTable
                          dataSource={pastTripDetails}
                          paginationConfig={paginationConfig}
                          handleServiceUser={handleMemberProfileDrawer}
                        />
                      </TabPane>

                      <TabPane tab="Favorites" key="3">
                        <ServicesTable
                          dataSource={favoriteTripDetails}
                          paginationConfig={paginationConfig}
                          handleServiceUser={handleMemberProfileDrawer}
                        />
                      </TabPane>
                    </Tabs>
                  </Col>
                )}
              </Col>
            </Row>
          </Card>
        </Col>

        <Col
          lg={6}
          xs={!showMobileDashboardView ? 24 : 0}
          className={styles.rightSideContainer}
        >
          <YourPlan />

          <Payment />

          <DashBoardFilter
            isOpenFilter={isOpenFilter}
            setIsOpenFilter={setIsOpenFilter}
            onUpcomingDateRangeChange={handleUpcomingDateRangeChange}
            onPastDateRangeChange={handlePastDateRangeChange}
          />
        </Col>
      </Row>

      {selectedServiceUser && (
        <ServiceSelectionDrawer
          profile={selectedServiceUser}
          isServiceSelectionDrawer={isServiceSelectionDrawer}
          setIsServiceSelectionDrawer={setIsServiceSelectionDrawer}
        />
      )}

      {memberProfileDetails && (
        <ViewProfileDrawer
          profile={memberProfileDetails}
          updateViewProfileDetails={updateProfile}
          isVisible={isOpenMemberProfileDrawer}
          setVisibility={setIsOpenMemberProfileDrawer}
        />
      )}
    </>
  );
};

export default DashBoard;
